var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main animated fadeIn faster",class:{ 'expand-main': _vm.isMenuCollapse }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{attrs:{"src":"https://adaptive-nectarine-029.notion.site/ebd/2556c45e956880f6ba5ed1c247c33cbb","width":"100%","height":"600","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }